import graphQLClient from "../../utils/authHeader";
import {
  GET_USER_WALLET,
  GET_USER_WALLETS,
  GET_ALL_USER_WALLETS,
} from "../../utils/queries/wallet/getWallet";
import ADD_WALLET_MUTATION from "../../utils/mutations/wallet/addWalletMutation";
import { getDecimalAmount, getBalanceAmount } from "../../utils/web3/formatBalance";
import { erc20ABI } from "../../utils/abis/erc20ABI";
import web3Helper from "../../services/web3";
import { Hash, WaitForTransactionReceiptTimeoutError } from "viem";

enum BlockchainName {
  ETHEREUM = 'ETHEREUM',
  BSC = 'BSC',
  AVALANCHE = 'AVALANCHE',
  POLYGON = 'POLYGON',
  TERRA = 'TERRA',
  APTOS = 'APTOS',
  POLKADOT = 'POLKADOT',
  MOONBEAM = 'MOONBEAM',
  CARDANO = 'CARDANO',
  ARBITRUM = 'ARBITRUM',
  SOLANA = 'SOLANA',
  FLOW = 'FLOW',
  BITCOIN = 'BITCOIN',
  PARTISIA = 'PARTISIA',
  NIBIRU = 'NIBIRU',
  BASE = 'BASE',
  ABSTRACT = 'ABSTRACT',
  OPTIMISM = 'OPTIMISM',
}

export const ChainName = (chainId: any) => {
  var chainName;
  switch (chainId) {
    case 1:
      chainName = "Ethereum Mainnet";
      break;
    case 11155111:
      chainName = "Sepolia Test Network";
      break;
    case 56:
      chainName = "Binance Smart Chain";
      break;
    case 97:
      chainName = "Binance Test Chain";
      break;
    case 43113:
      chainName = "Avalanche FUJI C-Chain"
      break;
    case 43114:
      chainName = "Avalance Mainnet C-Chain"
      break;
    case 42161:
      chainName = "Arbitrum Network"
      break;
    case 421613:
      chainName = "Arbitrum Goerli Network"
      break;
    case 137:
      chainName = "Polygon Network"
      break;
    case 80001:
      chainName = "Polygon Mumbai"
      break;
    case 8453:
      chainName = "Base Network"
      break;
    case 84532:
      chainName = "Base Sepolia Network"
      break;
    case 2741:
      chainName = "Abstract Network"
      break;
    case 11124:
      chainName = "Abstract Testnet"
      break;
    case 10:
      chainName = "Optimism Mainnet"
      break;
    case 11155420:
      chainName = "Optimism Sepolia Network"
      break;
  }
  return chainName;
};

export const NetworkId = (chainId: any) => {
  var networkId;

  switch (chainId) {
    case 1:
      networkId = "ETH_MAINNET";
      break;
    case 11155111:
      networkId = "ETH_TESTNET";
      break;
    case 56:
      networkId = "BSC_MAINNET";
      break;
    case 97:
      networkId = "BSC_TESTNET";
      break;
    case 43113:
      networkId = "AVALANCHE_TESTNET"
      break;
    case 43114:
      networkId = "AVALANCHE_MAINNET"
      break;
    case 42161:
      networkId = "ARBITRUM_MAINNET"
      break;
    case 421613:
      networkId = "ARBITRUM_TESTNET"
      break;
    case 137:
      networkId = "POLYGON_MAINNET"
      break;
    case 80001:
      networkId = "POLYGON_TESTNET"
      break;
    case 8453:
      networkId = "BASE_MAINNET"
      break;
    case 84532:
      networkId = "BASE_TESTNET"
      break;
    case 2741:
      networkId = "ABSTRACT_MAINNET"
      break;
    case 11124:
      networkId = "ABSTRACT_TESTNET"
      break;
    case 10:
      networkId = "OPTIMISM_MAINNET"
      break;
    case 11155420:
      networkId = "OPTIMISM_TESTNET"
      break;
  }

  return networkId;
};

export const ChainFromNetworkId = (networkId: any) => {
  var chainId;

  switch (networkId) {
    case 'ETH_MAINNET':
      chainId = 1;
      break;
    case 'ETH_TESTNET':
      chainId = 11155111;
      break;
    case 'BSC_TESTNET':
      chainId = 97;
      break;
    case 'BSC_MAINNET':
      chainId = 56;
      break;
    case 'AVALANCHE_TESTNET':
      chainId = 43113;
      break;
    case 'AVALANCHE_MAINNET':
      chainId = 43114;
      break;
    case 'ARBITRUM_MAINNET':
      chainId = 42161;
      break;
    case 'ARBITRUM_TESTNET':
      chainId = 421613;
      break;
    case 'POLYGON_MAINNET':
      chainId = 137;
      break;
    case 'POLYGON_TESTNET':
      chainId = 80001;
      break;
    case 'BASE_MAINNET':
      chainId = 8453;
      break;
    case 'BASE_TESTNET':
      chainId = 84532;
      break;
    case 'ABSTRACT_MAINNET':
      chainId = 2741;
      break;
    case 'ABSTRACT_TESTNET':
      chainId = 11124;
      break;
    case 'OPTIMISM_MAINNET':
      chainId = 10;
      break;
    case 'OPTIMISM_TESTNET':
      chainId = 11155420;
      break;   
  }

  return chainId;
}

export const NetworkName = (networkId: any) => {
  var name;
  switch (networkId) {
    case "ETH_MAINNET":
      name = "Ethereum Mainnet";
      break;

    case "ETH_TESTNET":
      name = "Sepolia Network";
      break;

    case "BSC_MAINNET":
      name = "Binance Smart Chain";
      break;

    case "BSC_TESTNET":
      name = "BSC Test Network";
      break;
    case "BASE_MAINNET":
      name = "Base Network";
      break;
    case "BASE_TESTNET":
      name = "Base Sepolia Network";
      break;
    case "ABSTRACT_MAINNET":
      name = "Abstract Network";
      break;
    case "ABSTRACT_TESTNET":
      name = "Abstract Sepolia Network";
      break;
    case "OPTIMISM_MAINNET":
      name = "Optimism Mainnet";
      break;
    case "OPTIMISM_TESTNET":
      name = "Optimism Sepolia Network";
      break;
  }

  return name;
};

export const getSymbol = async (chainId: number, tokenAddress: any) => {
  const cachedSymbol = localStorage.getItem(`${tokenAddress}-${chainId}-symbol`);
  if (cachedSymbol) {
    return cachedSymbol;
  } else {
    const tokenContract = await web3Helper.getERC20Contract(chainId, tokenAddress);
    const symbol = await tokenContract.read.symbol();
    localStorage.setItem(`${tokenAddress}-${chainId}-symbol`, symbol);
    return symbol;
  }
};

export const getDecimal = async (
  chainId: number,
  tokenAddress: any,
) => {
  const tokenInstance = await web3Helper.getERC20Contract(
    chainId,
    tokenAddress,
  );
  let decimals = await tokenInstance.read.decimals()
  return Number(decimals);
};

export const LockToken = (
  chainId: any,
  tokenAmount: any,
  duration: any,
  subid: string,
  tokenAddress: any
) => {
  // Get Connected Chain Name and network
  return new Promise(async (resolve, reject) => {
    const decimals = await getDecimal(chainId, tokenAddress);
    const value = getDecimalAmount(tokenAmount.toString(), decimals).toString();
    const durationInSeconds = duration * 30 * 24 * 60 * 60;
    web3Helper.createGainsLockedWallet(
      [
        BigInt(value),
        BigInt(durationInSeconds),
        subid
      ],
    )
      .then((receipt: any) => {
        resolve(receipt.transactionHash);
      })
      .catch((e: any) => {
        reject(e);
      });
  });
};

export const GetUserWallet = () => {
  return new Promise((resolve, reject) => {
    graphQLClient
      .request(GET_USER_WALLET)
      .then((data) => {
        resolve(data.getWalletByUserId);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const GetUserWallets = () => {
  return new Promise((resolve, reject) => {
    graphQLClient
      .request(GET_USER_WALLETS)
      .then((data) => {
        resolve(data.getWalletsByUserId);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const GetAllUserWallets = () => {
  return new Promise((resolve, reject) => {
    graphQLClient
      .request(GET_ALL_USER_WALLETS)
      .then((data) => {
        resolve(data.getAllWalletsByUserId);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const AddWallet = (message: string, address: string,  signature: string) => {
  return new Promise((resolve, reject) => {
    const blockchain = BlockchainName.ETHEREUM;
    const variables = {
      address: address,
      signature: {
        msg: message,
        sig: signature,
      },
      msgConfirmation: message,
      blockchain,
    };
    graphQLClient
      .request(ADD_WALLET_MUTATION, variables)
      .then((data) => {
        resolve(data.addWallet);
      })
      .catch((err: any) => {
        reject(err);
      })
  });
};

export const ApproveTokenSpent = (
  library: any,
  chainId: number,
  tokenAmount: any,
  source: any,
  tokenAddress: any,
  spender: any
) => {
  return new Promise(async (resolve, reject) => {
    const decimals = await getDecimal(chainId, tokenAddress);
    // const amount = BigNumber.from(tokenAmount).mul(
    //   BigNumber.from(10).pow(decimals)
    // );

    try {
      const approvalReceipt = await web3Helper.approveTokenSpend(
        chainId,
        tokenAddress,
        tokenAmount.toString(),
        spender,
      );
      resolve(approvalReceipt.transactionHash);
    } catch (e) {
      reject(e);
    }
  });
};

export const getContributionDetailsSC = (
  chainId: number,
  contributionScAddress: any,
  tokenAddress: string,
) => {
  return new Promise(async (resolve, reject) => {
    try {
      const contractInstance = await web3Helper.getPledgeContract(
        contributionScAddress,
        chainId,
      )
      const decimals = await getDecimal(chainId, tokenAddress);
      const contributionDetails: any = await contractInstance.read.contribution();
      const cap = getBalanceAmount(contributionDetails.cap.toString(), decimals).toNumber();
      const amount = getBalanceAmount(contributionDetails.amount.toString(), decimals).toNumber();
      resolve({ cap, amount });
    } catch (e) {
      console.error(e)
      reject(e);
    }
  })
}

export const ContributeToPool = (
  source: any,
  tokenAmount: any,
  proof: any,
  contractAddress: any,
  tokenAddress: any,
  maxValue: any,
  chainId: any
) => {
  return new Promise(async (resolve, reject) => {
    const decimals = await getDecimal(chainId, tokenAddress);
    const value = getDecimalAmount(tokenAmount, decimals).toString();
    const maxValueInDecimals = getDecimalAmount(maxValue, decimals).toString();

    try {
      const receipt = await web3Helper.contributeWithPledge(
        [
          contractAddress,
          source,
          BigInt(value.toString()),
          BigInt(maxValueInDecimals.toString()),
          proof
        ],
        source,
      );
      resolve(receipt.transactionHash);
    } catch (e) {
      console.log(e);
      reject(e);
    }
  });
};

export const StakeTokenFunction = (
  tokenAmount: any,
  contractAddress: `0x${string}`,
  chainId: number,
  tokenAddress: `0x${string}`
) => {
  return new Promise(async (resolve, reject) => {
    const decimals = await getDecimal(chainId, tokenAddress);
    const value = getDecimalAmount(tokenAmount, decimals).toString();
    try {
      const receipt = await web3Helper.stakeToken(
        [
          BigInt(value.toString())
        ],
        contractAddress
      );
      resolve(receipt.transactionHash)
    } catch (e) {
      console.log(e)
      reject(e)
    }
  })
}

export const ClaimToken = (
  chainId: number,
  proof: any,
  tokenAmount: any,
  tokenAddress: any,
  claimTokenContractAddress: any,
  source: `0x{string}`,
) => {
  return new Promise(async (resolve, reject) => {
    const decimals = await getDecimal(chainId, tokenAddress);
    const value = getDecimalAmount(tokenAmount, decimals);
    try {
      const receipt = await web3Helper.claimToken(
        claimTokenContractAddress,
        [
          proof,
          BigInt(value)
        ],
        source,
        );
      resolve(receipt.transactionHash);
    } catch (e) {
      console.log(e);
      reject(e);
    }
  });
};

export const RelockGains = (
  source: any,
  existingSubscriptionId: string,
  newSubscriptionId: string,
  duration: any,
  scVersion: number,
) => {
  return new Promise(async (resolve, reject) => {
    const durationInSeconds = duration * 30 * 24 * 60 * 60;
    try {
      const receipt =
        await web3Helper.relockWallet(
          [
            existingSubscriptionId,
            newSubscriptionId,
            BigInt(durationInSeconds),
          ],
          source,
          scVersion,
        );
      resolve(receipt.transactionHash);
    } catch (e) {
      console.log(e);
      reject(e);
    }
  });
};

export const WithdrawGains = (
  source: any,
  subscriptionId: string,
  scVersion: number,
) => {
  return new Promise(async (resolve, reject) => {
    try {
      const receipt = await web3Helper.withdrawGainsFromLockedWallet([subscriptionId], source, scVersion);
      resolve(receipt.transactionHash);
    } catch (e) {
      console.log(e);
      reject(e);
    }
  });
};

export const getTotalClaimed = async (
  chainId: number,
  claimContractAddress: any,
  address: any
) => {
    const claimTokenInstance = web3Helper.getClaimContract(chainId, claimContractAddress);
    const tokenClaimed = await claimTokenInstance.read.tokenClaimed([address]);
    const tokenAddress = await claimTokenInstance.read.token() as `0x{string}`;
    const tokenInstance = await web3Helper.getERC20Contract(chainId, tokenAddress);
    const decimals = await tokenInstance.read.decimals();
    return {tokenClaimed, decimals};
};

export const waitForTransactionReceipt = (error: WaitForTransactionReceiptTimeoutError): Promise<Hash> => {
  return new Promise(async (resolve, reject) => {
    try {
      const hashRegex = /0x[a-fA-F0-9]{64}/;
      const match = error.message.match(hashRegex);
      if (!match) {
        throw new Error('Unable to extract transaction hash from error message');
      }
      const hash = match[0] as Hash;
      const receipt = await web3Helper.waitOrTimeoutForTransactionReceipt(hash, 0);
      resolve(receipt.transactionHash);
    } catch (e) {
      reject(e);
    }
  });
}